// extracted by css-extract-rspack-plugin
export default {"header":"zcBe7zsFU4E8thjq__header___","ellipsisWrapper":"jKZlwZNiiu8Npml3__ellipsisWrapper___","title":"xKaTWTYffWcXG8DJ__title___"};